module.exports = __webpack_public_path__ + "media/assets/images/flags/gp-8f395f494ec49a596e3cb4213a864200.svg";